// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603171506/js/" + chunkId + "." + {"44":"26df9ad5","225":"0dd82e39","481":"254d483c","486":"10586196","770":"d071ad57"}[chunkId] + ".0.7213624447065594.chunk.js";
};